import React, { useState, useRef, useEffect } from 'react';
import { LanguageIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSelector = ({ variant = 'light' }) => {
  const { lang, changeLang, currentLang, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const baseClasses =
    variant === 'dark'
      ? 'text-gray-300 hover:text-white border-white/20 hover:border-white/40'
      : 'text-[#64748B] hover:text-[#FF6B00] border-gray-200 hover:border-orange-300';

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`flex items-center space-x-1.5 px-2.5 py-1.5 text-xs sm:text-sm font-medium rounded-lg border transition-colors ${baseClasses}`}
        aria-label="Select language"
      >
        <LanguageIcon className="h-4 w-4" />
        {currentLang.svg && (
          <img
            src={`https://flagcdn.com/16x12/${currentLang.svg}.png`}
            alt={currentLang.label}
            className="h-3 w-4 rounded-sm object-cover"
          />
        )}
        <span className="hidden sm:inline">{currentLang.label}</span>
      </button>
      {open && (
        <div className="absolute top-full mt-1 right-0 bg-white border border-gray-200 rounded-lg shadow-lg py-1 z-50 min-w-[140px]">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                changeLang(l.code);
                setOpen(false);
              }}
              className={`flex items-center space-x-2 w-full px-4 py-2 text-sm text-left hover:bg-orange-50 transition-colors ${
                l.code === lang ? 'text-[#FF6B00] font-semibold' : 'text-[#64748B]'
              }`}
            >
              {l.svg && (
                <img
                  src={`https://flagcdn.com/16x12/${l.svg}.png`}
                  alt={l.label}
                  className="h-3 w-4 rounded-sm object-cover"
                />
              )}
              <span>{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
